import axios from 'axios';
import { settings as s } from '../Settings';
import { getAccessToken } from '../Settings';
const getUrl = (ep) => `${s.baseUrl}${ep}`;
const guestToken = `token ${s.guestToken}`;
const accessToken = localStorage.getItem('accessToken');
export const getData = async (relativeUrl, user) => {
	const url = getUrl(relativeUrl);
	const options = {
		headers: {
			Authorization: `Bearer ${localStorage.getItem('accessToken')}` || null,
			'Content-Type': 'application/json-patch+json',
			Accept: '*/*',
		},
	};
	try {
		const response = await axios.get(url, options).then((res) => res);
		return { status: response.status, data: response.data };
	} catch (err) {
		if (err.response) {
			return { status: err.response.status, data: [] };
		}
		return { status: 0, data: [] };
	}
};

export const getDataAnonymously = async (relativeUrl) => {
	const url = getUrl(relativeUrl);
	const options = {
		headers: {
			'Content-Type': 'application/json-patch+json',
			Accept: '*/*',
		},
	};
	try {
		const response = await axios.get(url, options).then((res) => res);
		return { status: response.status, data: response.data };
	} catch (err) {
		if (err.response) {
			return { status: err.response.status, data: [] };
		}
		return { status: 0, data: [] };
	}
};

export const postData = async (relativeUrl, data, API) => {
	const url = getUrl(relativeUrl);
	const config = {
		method: 'post',
		url,
		headers: {
			Authorization:
				API === 'login' || API === 'signup' || API === 'verify' || API === 'fp'
					? null
					: `Bearer ${localStorage.getItem('accessToken')}`,
			'Content-Type': 'application/json',
			Accept: '*/*',
		},
		data,
	};

	try {
		const response = await axios(config)
			.then((res) => res)
			.catch((error) => error);
		return response;
	} catch (err) {
		return { status: null };
	}
};

export const postFormData = async (relativeUrl, user, data) => {
	console.log('data from API CALLS : ', data);
	const url = getUrl(relativeUrl);
	const config = {
		method: 'post',
		url,
		headers: {
			Authorization: `Bearer ${localStorage.getItem('accessToken')}` || null,
			'Content-Type': 'multipart/form-data',
			Accept: '*/*',
		},
		data,
	};

	try {
		const response = await axios(config)
			.then((res) => res)
			.catch((error) => error);
		return response;
	} catch (err) {
		return { status: null };
	}
};

export const postDataAnonymously = async (relativeUrl, data) => {
	const url = getUrl(relativeUrl);
	const config = {
		method: 'post',
		url,
		headers: {
			'Content-Type': 'application/json-patch+json',
			Accept: '*/*',
		},
		data,
	};

	try {
		const response = await axios(config)
			.then((res) => res)
			.catch((error) => error.response);
		return response;
	} catch (err) {
		return { status: null };
	}
};

export const resetPassword = async (relativeUrl, user, data) => {
	const url = getUrl(relativeUrl);
	const config = {
		method: 'post',
		url,
		headers: {
			Authorization:
				accessToken === 'undefined' || accessToken === 'null'
					? guestToken
					: `Bearer ${accessToken}`,
			'Content-Type': 'application/json-patch+json',
			Accept: '*/*',
		},
		data,
	};

	try {
		const response = await axios(config)
			.then((res) => res)
			.catch((error) => error);
		return response;
	} catch (err) {
		return { status: null };
	}
};

export const postFile = async (relativeUrl, user, data) => {
	const url = getUrl(relativeUrl);
	const config = {
		method: 'post',
		url,
		headers: {
			Authorization: `Bearer ${localStorage.getItem('accessToken')}` || null,
			'Content-Type': 'application/json-patch+json',
			Accept: '*/*',
		},
		data,
	};

	try {
		const response = await axios(config)
			.then((res) => res)
			.catch((error) => error);
		return response;
	} catch (err) {
		return { status: null };
	}
};

export const putData = async (relativeUrl, data) => {
	const url = getUrl(relativeUrl);
	const config = {
		method: 'put',
		url,
		headers: {
			Authorization: `Bearer ${localStorage.getItem('accessToken')}` || null,
			'Content-Type': 'application/json',
		},
		data,
	};

	try {
		const response = await axios(config)
			.then((res) => res)
			.catch((error) => error);
		return response;
	} catch (err) {
		return { status: null };
	}
};

export const putFormData = async (relativeUrl, user, data) => {
	const url = getUrl(relativeUrl);

	const config = {
		method: 'put',
		url,
		headers: {
			Authorization: `Bearer ${localStorage.getItem('accessToken')}` || null,
			'Content-Type': 'multipart/form-data',
			Accept: '*/*',
		},
		data,
	};

	try {
		const response = await axios(config)
			.then((res) => res)
			.catch((error) => error);
		return response;
	} catch (err) {
		return { status: null };
	}
};

// for put API without user
export const putFormDataWithoutUser = async (relativeUrl, data) => {
	const url = getUrl(relativeUrl);

	const config = {
		method: 'put',
		url,
		headers: {
			Authorization:
				accessToken === 'undefined' || accessToken === 'null'
					? guestToken
					: `Bearer ${accessToken}`,
			'Content-Type': 'multipart/form-data',
			Accept: '*/*',
		},
		data,
	};

	try {
		const response = await axios(config)
			.then((res) => res)
			.catch((error) => error);
		return response;
	} catch (err) {
		return { status: null };
	}
};

export const deleteData = async (relativeUrl) => {
	const url = getUrl(relativeUrl);
	const options = {
		headers: {
			Authorization: `Bearer ${localStorage.getItem('accessToken')}` || null,
			'Content-Type': 'application/json-patch+json',
			Accept: '*/*',
		},
	};

	try {
		const response = await axios
			.delete(url, options)
			.then((res) => res)
			.catch((error) => error);
		return response;
	} catch (err) {
		return { status: null };
	}
};

export const FormDataPost = async (relativeUrl, data) => {
	const url = getUrl(relativeUrl);
	const config = {
		method: 'post',
		url,
		headers: {
			Authorization: `Bearer ${localStorage.getItem('accessToken')}` || null,
			'Content-Type': 'multipart/form-data',
			Accept: '*/*',
		},
		data,
	};

	try {
		const response = await axios(config)
			.then((res) => res)
			.catch((error) => error);
		return response;
	} catch (err) {
		return { status: null };
	}
};
